module.exports = __webpack_public_path__ + "assets/img/error.27327bac.png";